import { render, staticRenderFns } from "./nbq_power_manage.vue?vue&type=template&id=258468ea&"
import script from "./nbq_power_manage.vue?vue&type=script&lang=js&"
export * from "./nbq_power_manage.vue?vue&type=script&lang=js&"
import style0 from "./nbq_power_manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports